var AutoCloseHandler = /** @class */ (function () {
    function AutoCloseHandler(component) {
        var _this = this;
        this.component = component;
        var click = function (event) {
            if (_this.isParent(component.hostElement, event.target)) {
                return; //Ignore mouseevent if it comes from the same component
            }
            component.close();
        };
        var onOpen = function () {
            window.addEventListener('mouseup', click);
        };
        var onClose = function () {
            window.removeEventListener('mouseup', click);
        };
        component.hostElement.addEventListener('csmOpen', onOpen);
        component.hostElement.addEventListener('csmClose', onClose);
    }
    AutoCloseHandler.prototype.toggle = function () {
        if (this.component.disabled) {
            return;
        }
        if (this.component.isOpen) {
            this.component.close();
        }
        else {
            this.component.open();
        }
    };
    AutoCloseHandler.prototype.isParent = function (parent, element) {
        if (element == null || element === document) {
            return false;
        }
        if (element === parent) {
            return true;
        }
        return this.isParent(parent, element.parentElement);
    };
    return AutoCloseHandler;
}());
export { AutoCloseHandler as A };
